import { SVGProps, Ref, forwardRef } from 'react';

export const SendWebFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="m5.288 4.045-3.37 6.833C.713 13.325.11 14.548.777 15.196c.668.647 2.065.193 4.86-.714l.532-.172 1.831-8.058 1.832 8.057.532.173c2.796.907 4.193 1.36 4.86.714s.065-1.87-1.142-4.318l-3.369-6.833C9.547 1.682 8.964.5 8 .5S6.453 1.682 5.288 4.045"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
SendWebFilledSize16Glyph.displayName = 'SendWebFilledSize16Glyph';
